// src/features/expenses/components/ExpenseCategoryManagement/index.jsx
// ✅ منقول من src/components/ExpenseCategoryManagement.js
// التغيير الوحيد: مسارات الاستيراد

import React, { useState, useEffect, useCallback } from 'react';
import api        from '../../../../api/axiosInstance';
import styles     from './ExpenseCategoryManagement.module.css';
import formStyles from '../../../../components/Form.module.css';
import { useAuth } from '../../../auth/context/AuthContext';

function ExpenseCategoryManagement() {
    const [categories,       setCategories]       = useState([]);
    const [formData,         setFormData]          = useState({ name: '', is_booking_related: false });
    const [editingCategory,  setEditingCategory]   = useState(null);
    const [loading,          setLoading]           = useState(true);
    const [error,            setError]             = useState('');
    const [success,          setSuccess]           = useState('');
    const { hasPermission } = useAuth();

    const fetchCategories = useCallback(async () => {
        setLoading(true);
        try {
            const response = await api.get('/expense-categories/');
            setCategories(response.data);
        } catch (err) {
            setError('فشل في جلب قائمة الحسابات.');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { fetchCategories(); }, [fetchCategories]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
    };

    const handleEditClick = (category) => {
        setEditingCategory(category);
        setFormData(category);
        setSuccess('');
        setError('');
        window.scrollTo(0, 0);
    };

    const handleCancelEdit = () => {
        setEditingCategory(null);
        setFormData({ name: '', is_booking_related: false });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        if (!hasPermission('manage_expense_categories')) {
            setError('لا تملك الصلاحية لإدارة حسابات المصاريف.');
            return;
        }
        if (!formData.name) {
            setError('اسم الحساب حقل إلزامي.');
            return;
        }

        if (editingCategory) {
            try {
                await api.patch(`/expense-categories/${editingCategory.id}/`, formData);
                setSuccess(`تم تحديث الحساب "${formData.name}" بنجاح!`);
                handleCancelEdit();
                fetchCategories();
            } catch (err) {
                setError(err.response?.data?.name?.[0] || 'حدث خطأ أثناء التحديث.');
            }
        } else {
            try {
                await api.post('/expense-categories/', formData);
                setSuccess(`تمت إضافة حساب "${formData.name}" بنجاح!`);
                setFormData({ name: '', is_booking_related: false });
                fetchCategories();
            } catch (err) {
                setError(err.response?.data?.name?.[0] || 'حدث خطأ غير متوقع.');
            }
        }
    };

    return (
        <div className={styles.pageContainer}>
            {hasPermission('manage_expense_categories') && (
                <div className={styles.formSection}>
                    <h2>{editingCategory ? `تعديل الحساب: ${editingCategory.name}` : 'إضافة حساب مصروف جديد'}</h2>
                    <form onSubmit={handleSubmit} className={formStyles.form}>
                        <input
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="اسم الحساب (مثال: مواصلات، إيجار)"
                            required
                        />
                        <div className={styles.checkboxContainer}>
                            <input
                                type="checkbox"
                                id="is_booking_related"
                                name="is_booking_related"
                                checked={formData.is_booking_related}
                                onChange={handleChange}
                            />
                            <label htmlFor="is_booking_related">
                                هذا الحساب خاص بالمصاريف المتعلقة بالحجوزات فقط
                            </label>
                        </div>

                        {error   && <p className={formStyles.errorMessage}>{error}</p>}
                        {success && <p className={styles.successMessage}>{success}</p>}

                        <div className={styles.formActions}>
                            {editingCategory && (
                                <button type="button" onClick={handleCancelEdit} className={styles.cancelButton}>
                                    إلغاء
                                </button>
                            )}
                            <button type="submit" className={formStyles.submitButton}>
                                {editingCategory ? 'حفظ التعديلات' : '+ إضافة الحساب'}
                            </button>
                        </div>
                    </form>
                </div>
            )}

            <div className={styles.listSection}>
                <h2>قائمة الحسابات ({categories.length})</h2>
                {loading ? <p>جاري التحميل...</p> : (
                    <div className={styles.categoryList}>
                        {categories.map(cat => (
                            <div key={cat.id} className={styles.categoryCard}>
                                <strong className={styles.categoryName}>{cat.name}</strong>
                                <div className={styles.cardControls}>
                                    <span className={`${styles.categoryType} ${cat.is_booking_related ? styles.bookingType : styles.generalType}`}>
                                        {cat.is_booking_related ? 'خاص بالحجوزات' : 'عام'}
                                    </span>
                                    {hasPermission('manage_expense_categories') && (
                                        <button onClick={() => handleEditClick(cat)} className={styles.editButton}>
                                            تعديل
                                        </button>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default ExpenseCategoryManagement;